<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center">
      <div class="bg-white rounded-[14px] w-[520px] flex flex-col items-center pt-[50px] pb-[44px] px-[60px]">
        <img src="assets/images/icones/session-closed.png" alt="" class="size-[68px] object-contain" />

        <p class="fg-noir-2 text-[19px] font-semibold mt-[15px] mb-0 text-center leading-none">
          {{ 'session.closed.title' | translate }}
        </p>

        <p class="fg-gris-1 text-[14px] text-center mt-[15px] mb-0 leading-[20.8px] w-[376px]">
          {{ 'session.closed.description' | translate }}
        </p>

        <div
          class="bg-orange-3 rounded-[6px] w-full min-h-[80px] grid grid-cols-[repeat(3,minmax(0,auto))] gap-[15px] px-[30px] py-[14px] mt-[30px]">
          <div class="flex flex-col gap-[6px] min-w-0">
            <span class="fg-noir-2-contour text-[14px] font-light leading-none">
              {{ 'common.terminal' | translate }}
            </span>
            <span class="fg-noir-2 text-[14px] font-semibold leading-tight line-clamp-2 min-w-0">
              {{ sessionInfo().cashRegisterName | capitalize }}
            </span>
          </div>

          <div class="flex flex-col gap-[6px] min-w-0">
            <span class="fg-noir-2-contour text-[14px] font-light leading-none">
              {{ 'common.location' | translate }}
            </span>
            <span class="fg-noir-2 text-[14px] font-semibold leading-tight line-clamp-2 min-w-0">
              {{ sessionInfo().locationName | capitalize }}
            </span>
          </div>

          <div class="flex flex-col gap-[6px] min-w-0">
            <span class="fg-noir-2-contour text-[14px] font-light leading-none">
              {{ 'common.service' | translate }}
            </span>
            <span class="fg-noir-2 text-[14px] font-semibold leading-tight line-clamp-2 min-w-0">
              {{ sessionInfo().serviceName | capitalize }}
            </span>
          </div>
        </div>

        <button type="button"
          class="bg-vert-1 w-[400px] h-[58px] rounded-[5px] text-white text-[16px] font-semibold mt-[20px] cursor-pointer hover:brightness-95 transition-colors"
          (click)="openSession()">
          {{ 'session.closed.open_session' | translate }}
        </button>

        @if (lastSessionDate()) {
        <p class="fg-gris-1 text-[14px] text-center mt-[36px] mb-0 leading-none">
          {{ 'session.closed.last_session' | translate }} :
          {{ lastSessionDate() | capitalize }}
        </p>
        }
      </div>
    </div>
  </main>
</div>